export default function () {
  const confSpeakersList = document.querySelectorAll('.winter-conference__speaker');
  const confSpeakersBtns = document.querySelectorAll('.winter-conference__speaker-button');
  const showSpeakersBtn = document.querySelector('.winter-conference__show-speakers-btn');

  if (!confSpeakersList || !confSpeakersBtns) {
    return;
  }

  confSpeakersBtns.forEach((openBtn, index) => {
    const speakerDialog = document.getElementById(`winter-conference-dialog-${index}`);
    const closeBtn = speakerDialog.querySelector('.winter-conference-dialog__close-btn');

    openBtn.addEventListener('click', () => {
      speakerDialog.showModal();
    });

    closeBtn.addEventListener('click', () => {
      speakerDialog.close();
    });
  });

  if (!showSpeakersBtn) {
    return;
  }

  showSpeakersBtn.addEventListener('click', () => {
    confSpeakersList.forEach((speaker) => {
      speaker.setAttribute('data-show-speaker', true);
    });

    showSpeakersBtn.style.display = 'none';
  });
}
